::ng-deep particle-support-comment-dialog,::ng-deep particle-comment-dialog{display:flex;width:100%}::ng-deep particle-support-comment-dialog .rest-of,::ng-deep particle-comment-dialog .rest-of{height:600px}
/*# sourceMappingURL=comment-dialog.component-BSWIZUJS.css.map */
